var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListTaskSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.526,
    height: 19.038,
    viewBox: "0 0 25.526 19.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list-task_1_",
    "data-name": "list-task (1)",
    transform: "translate(-1.25 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_361",
    "data-name": "Trazado 361",
    d: "M2.427,2.5a.927.927,0,0,0-.927.927V5.281a.927.927,0,0,0,.927.927H4.281a.927.927,0,0,0,.927-.927V3.427A.927.927,0,0,0,4.281,2.5Zm1.854.927H2.427V5.281H4.281Z",
    transform: "translate(0 0)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_362",
    "data-name": "Trazado 362",
    d: "M5,3.927A.927.927,0,0,1,5.927,3H22.611a.927.927,0,0,1,0,1.854H5.927A.927.927,0,0,1,5,3.927Zm.927,6.488a.927.927,0,1,0,0,1.854H22.611a.927.927,0,0,0,0-1.854Zm0,7.415a.927.927,0,1,0,0,1.854H22.611a.927.927,0,1,0,0-1.854Z",
    transform: "translate(2.988 0.427)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_363",
    "data-name": "Trazado 363",
    d: "M1.5,7.427A.927.927,0,0,1,2.427,6.5H4.281a.927.927,0,0,1,.927.927V9.281a.927.927,0,0,1-.927.927H2.427A.927.927,0,0,1,1.5,9.281Zm.927,0H4.281V9.281H2.427Zm0,6.488a.927.927,0,0,0-.927.927V16.7a.927.927,0,0,0,.927.927H4.281a.927.927,0,0,0,.927-.927V14.842a.927.927,0,0,0-.927-.927Zm1.854.927H2.427V16.7H4.281Z",
    transform: "translate(0 3.415)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListTaskSettings);
export default __webpack_public_path__ + "static/media/list-task-settings.4073579368d015b482df6a020c0fb37c.svg";
export { ForwardRef as ReactComponent };